<template>
    <div id="dispositivo">
        <br /><br />
        <br /><br />
        <h1 style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold " v-if="esRecogidaEnTienda">3. Datos del dispositivo</h1>
        <h1 style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold " v-else>4. Datos del dispositivo</h1>
        <br /><br />
        <br /><br />
        <!-- ERROR EN LA API -->
        <template v-if="!hayDatosMinimos">
            <div style="margin:0" class="maxWidth">
                <v-alert class="mt-3" dense type="warning" style="font-family: Heebo; font-weight: normal"> No se han obtenido correctamente los datos necesarios para la selección del dispositivo </v-alert>
                <v-row justify="center" no-gutters>
                    <v-btn color="#9be51a" dark x-large @click="getBasicData()">RECARGAR</v-btn>
                </v-row>
            </div>
        </template>

        <template v-else>
            <div style="margin:0" class="form-fieldset module mb-0">
                <p  style="font-family: Heebo; font-weight: normal;margin:0;padding:0;font-size:16px">
                    Si no encuentra el fabricante y el modelo deseado para la reparación, contacte a nuestro servicio de atención al cliente 900 105 114
                </p>


                <!-- FABRICANTE -->
                <div class="form-row" style="margin:0">
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-40 elementor-field-required">
                            <v-autocomplete id="autoTipo" v-model="fabricante" :items="fabricantes" item-value="IDFABRICANTE" item-text="DESCRIPCION" size="60" type="text"
                                            placeholder="Fabricante * (teclee para autocompletar)"></v-autocomplete>
                            <p id="capa_modelo_error" class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ dispositivo.fabricanteError }}</p>
                        </div>
                    </div>

                </div>

                <!-- MODELO -->

                <div class="form-row" style="margin:0"
                     v-if="hayModelosFiltrados">
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-40 elementor-field-required">
                            <v-autocomplete id="autoModelo" v-model="modelo"
                                            :items="modelosFiltrados"
                                            item-value="IDMODELO"
                                            item-text="DESCRIPCION" size="60" type="text"
                                            placeholder="Modelo del dispositivo * (teclee para autocompletar)" return-object></v-autocomplete>
                            <p id="capa_modelo_error" class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ dispositivo.modelError }}</p>
                        </div>
                    </div>
                </div>

                <!-- GARANTIA -->
                <parrafo-garantias v-if="!this.$bus.formulario.company && hayModeloSeleccionado && hayCatalogo" :catalogos-reparacion="catalogosReparacion"></parrafo-garantias>

                <!-- SN -->
                <div class="form-row" style="margin:0">
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-40 elementor-field-required">
                            <input style="color: #606060" v-model="dispositivo.sn" maxlength="40" size="50" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Indicanos el número de serie del dispositivo (Opcional)">
                        </div>
                    </div>
                    <p class="text--s mt-1 mb-0 bolder" style="font-family: Heebo; font-weight: normal;font-size:14px;">Ejemplo: WB0236XXXX</p>
                    <p id="capa_sn_error" class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ dispositivo.snError }}</p>

                </div>


                <!-- SINTOMA -->
                <div class="form-row" style="margin:0" v-if="dispositivo.tipo != 0">
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-40 elementor-field-required">
                            <v-autocomplete v-model="dispositivo.symptom"
                                            :items="sintomas"
                                            item-value="ID_SINTOMA_CLIENTE"
                                            item-text="DESCRIPCION" size="60" type="text"
                                            placeholder="Modelo del dispositivo * (teclee para autocompletar)"
                                            :errors="dispositivo.symptomError!=''"></v-autocomplete>
                            <p id="capa_sintoma_error" class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ dispositivo.symptomError }}</p>
                        </div>
                    </div>
                </div>

               
                <div class="form-row" style="margin-top:20px;margin-bottom:10px">
                    <div style="font-family: Heebo;font-size:18px; font-weight: bold">Observaciones</div>
                    <div :class="'input input--text input--xl ' + (dispositivo.symptom_descriptionError != '' ? 'input-error' : '')">
                        <div class="input-item">
                            <textarea style="border: 0.5px solid #606060; border-radius: 4px; box-sizing: border-box; color: black; font-family: Heebo; font-weight: normal" v-model="dispositivo.symptom_description" rows="2" cols="20" id="txt_observaciones" class="text--s" placeholder="Descríbenos el problema del dispostivo *"></textarea>
                            <p id="capa_sintomaDesc_error" class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal; color: #606060;">{{ dispositivo.symptom_descriptionError }}</p>
                        </div>
                    </div>
                </div>


                <!-- ACCESORIOS -->
                <div class="form-row maxWidth" style="margin:0" v-if="dispositivo.tipo != 0">
                    <div class="title--xs mb-0" style="font-family: Heebo; font-weight: normal">Selecciona los accesorios que va a mandar con el dispositivo</div>
                    <!--<div class="controls mb-0">
            <v-row>
                <v-col cols="12" lg="4" v-for="accesorio in accesorios" :key="accesorio.IDACCESORIO">
                    <v-checkbox v-model="dispositivo.accesories" label="accesorio.DESCRIPCION" value="accesorio.IDACCESORIO"></v-checkbox>
                </v-col>
            </v-row>

        </div>-->
                    <div class="controls mb-0">
                        <v-row>
                            <v-col cols="12" lg="4" v-for="accesorio in accesorios" :key="accesorio.IDACCESORIO">
                                <input :id="accesorio.IDACCESORIO" type="checkbox" v-model="dispositivo.accesories" :value="accesorio.IDACCESORIO" />
                                <label class="text--s" :for="accesorio.IDACCESORIO" style="font-family: Heebo; font-weight: normal">{{ accesorio.DESCRIPCION }}</label>
                            </v-col>
                        </v-row>
                    </div>

                </div>
                <br />
                <br />
                <!-- EMBALAJE -->
                <div class="form-row" style="margin:0">
                    <div :class="'controls mb-1 ' + (especiales.embalajeError != '' ? 'input-error' : '')">
                        <input id="embolaje" type="checkbox" v-model="especiales.embalaje">
                        <label class="text--s" for="embolaje" style="font-family: Heebo; font-weight: normal">¿Necesita embalaje para su equipo?</label>
                        <p id="capa_embalaje_error" class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ especiales.embalajeError }}</p>
                    </div>
                </div>
                <div class="form-row maxWidth" style="margin:0">
                    <v-row v-if="especiales.embalaje">
                        <v-col cols="12" lg="4" v-for="embalaje in embalajes" :key="embalaje.IDEMBALAJE">
                            <v-card :class="'mx-auto ' + (embalaje.IDEMBALAJE == especiales.package ? 'seleccionado' : '')" max-width="400">
                                <v-card-text class="py-0">
                                    <v-row class="centrar-contenido">
                                        <v-icon class="icono-gigante">mdi-package-variant-closed</v-icon>
                                    </v-row>
                                    <v-row class="centrar-contenido">
                                        <p class="text--s" style="font-family: Heebo; font-weight: bold">{{embalaje.DESCRIPCION}}</p>
                                    </v-row>
                                    <v-list class="transparent">
                                        <v-list-item>
                                            <v-list-item-title style="font-family: Heebo; font-weight: normal">PESO MÁXIMO</v-list-item-title>
                                            <v-list-item-icon>
                                                <v-icon>mdi-weight-kilogram</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-subtitle>
                                                <p class="text--m texto-derecha" style="font-family: Heebo; font-weight: normal">{{ embalaje.PESO_MAXIMO | kilos }}</p>
                                            </v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-title style="font-family: Heebo; font-weight: normal">COSTE *</v-list-item-title>
                                            <v-list-item-icon>
                                                <v-icon>mdi-cash</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-subtitle>
                                                <p class="text--m texto-derecha" style="font-family: Heebo; font-weight: normal">{{ embalaje.PVP * 1.21 | precio }} *</p>
                                            </v-list-item-subtitle>
                                        </v-list-item>
                                    </v-list>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field :value="embalaje.ALTO + ' cm'" label="ALTO" style="font-family: Heebo; font-weight: normal" filled readonly hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field :value="embalaje.LARGO + ' cm'" label="LARGO" style="font-family: Heebo; font-weight: normal" filled readonly hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field :value="embalaje.ANCHO + ' cm'" label="ANCHO" style="font-family: Heebo; font-weight: normal" filled readonly hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-row class="centrar-contenido">
                                        <v-btn dark color="#9be51a" @click="seleccionarPaquete(embalaje.IDEMBALAJE, embalaje.PVP)" style="font-family: Heebo; font-weight: normal">SELECCIONAR</v-btn>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <p class="text--m" style="font-family: Heebo; font-weight: normal">* precios con IVA. Península y Baleares aplica el IVA 21%, Ceuta IPSI 10%, Melilla IPSI 8%, Canarias IGIC 7%</p>
                        </v-col>
                    </v-row>
                </div>
                <!-- GARANTIA -->
                <div class="form-row" style="margin:0">
                    <h2 style="font-family: Heebo; font-size: 22px; color: black; font-weight: normal ;margin-top:40px">Si tu dispositivo está en garantía y tienes la factura, mándanosla para evitar gestiones posteriores.</h2>


                    <div data-elementor-type="wp-page" data-elementor-id="4160" class="elementor elementor-4160" data-elementor-post-type="page" style="margin-left:0;padding-left:0">
                        <div style="margin-left:0;padding-left:0;margin-top:0;margin-bottom:40px" class="elementor-element elementor-element-4b2b6f4 elementor-mobile-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-button-align-stretch elementor-widget elementor-widget-form" data-id="4b2b6f4" data-element_type="widget" data-settings="{&quot;button_width&quot;:&quot;25&quot;,&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width_tablet&quot;:&quot;40&quot;,&quot;button_width_mobile&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                            <div style="margin-left: 0; padding-left: 0; margin-top: 0" class="elementor-field-type-html elementor-field-group elementor-column elementor-field-group-field_1b1544f elementor-col-100">
                                <div id="input-file-name">{{this.nombreFichero}}</div>
                            </div>
                            <div style="margin-left:0;padding-left:0" class="elementor-field-type-upload elementor-field-group elementor-column elementor-field-group-file elementor-col-20 elementor-md-100">
                                <label for="form-field-file" class="elementor-field-label elementor-screen-only">
                                    Subir factura
                                </label>
                                <input type="file" @change="changeFactura" name="form_fields[file]" id="form-field-file" class="elementor-field elementor-size-sm  elementor-upload-field" data-maxsize="8" data-maxsize-message="Este archivo excede el tamaño máximo permitido.">
                            </div>
                        </div>
                    </div>




                </div>
                <!-- PRESCRIPTOR - Solo particulares -->
                <div v-if="tipoDNI == 'DNI'" class="form-row" style="margin:0">
                    <div :class="'input input--text input--xl ' + (especiales.prescriptorError != '' ? 'input-error' : '')">
                        <label class="title--xs mb-0" style="font-family: Heebo; font-weight: normal">Si tienes código de prescriptor, indícalo (Opcional)</label>
                        <div class="input-item">
                            <input type="text" v-model="localPrescriptor" maxlength="40" class="text--s">
                            <p id="capa_prescriptor_error" class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ mensajePrescriptor }}{{ especiales.prescriptorError }}</p>
                        </div>
                    </div>
                </div>

                <!-- CONDICIONES -->
                <div class="form-row" style="margin:0">
                    <div>
                        <input id="condiciones" class="check_zeleris" type="checkbox" v-model="especiales.terminos" />
                        <label class="text--s" for="condiciones" style="font-family: Heebo; font-weight: normal">
                            <!--<router-link target="_blank" :href="getCondicionesAdecuadas()">He leido y acepto las <span class="enlace">Condiciones generales</span></router-link>-->
                            <router-link target="_blank" to="/condiciones" style="font-family: Heebo; font-weight: normal;font-size: 14px;">He leído y acepto las <span class="enlace" style="font-family: Heebo; font-weight: normal">Condiciones generales</span></router-link>
                        </label>
                        <p id="capa_terminos_error" class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ especiales.terminosError }}</p>
                    </div>
                    <div class="controls">
                        <p class="mt-2 text--s subrayado" style="font-family: Heebo; font-weight: normal">RECOMENDACIONES:</p>
                        <p class="text--s" style="font-family: Heebo; font-weight: normal; font-size: 14px;">
                            <ol>
                                <li style="font-family: Heebo; font-weight: normal;font-size: 14px;">Tenga listo el equipo antes de que pasen a recogerlo. Consulte <a class="enlace" target="_blank" href="https://www.zeleris.com/Media/Docs/Recomendaciones_Embalaje.pdf" style="font-family: Heebo; font-weight: normal">aquí</a> las recomendaciones de <span style="font-family: Heebo; font-weight: bold">embalaje</span>.</li>
                                <li style="font-family: Heebo; font-weight: normal; font-size: 14px;">Si tiene memoria, haga una <span style="font-family: Heebo; font-weight: bold; font-size: 14px;">copia de seguridad</span> de tu dispositivo.</li>
                                <li style="font-family: Heebo; font-weight: normal; font-size: 14px;">Elimine cualquier <span style="font-family: Heebo; font-weight: bold; font-size: 14px;">código de seguridad</span> de acceso al dispositivo y de las diferentes cuentas de todas las aplicaciones.</li>
                                <li style="font-family: Heebo; font-weight: normal; font-size: 14px;">Retire el <span style="font-family: Heebo; font-weight: bold; font-size: 14px;">protector de pantalla</span> si lo tuviera.</li>
                                <li style="font-family: Heebo; font-weight: normal; font-size: 14px;"><span style="font-family: Heebo; font-weight: bold; font-size: 14px;">No envíes</span>: La tarjeta SIM, tapas del teléfono, MicroSD, ni ningún otro accesorio.</li>
                                <li style="font-family: Heebo; font-weight: normal; font-size: 14px;">Siempre que sea posible aporte la copia de la <span style="font-family: Heebo; font-weight: bold; font-size: 14px;">factura de compra</span> o ticket de compra.</li>
                                <li style="font-family: Heebo; font-weight: normal; font-size: 14px;">Si su equipo se diagnostica fuera de garantía, recibirá un correo electrónico con un presupuesto indicando el coste de la reparación, y un coste de gestión que aplicaría <br />solo en caso de no aceptar el presupuesto de reparación.</li>
                                <li style="font-family: Heebo; font-weight: normal; font-size: 14px;">Si no aporta número de serie del dispositivo ni factura de compra no se podrá comprobar el estado de garantía, y se entenderá que es una solicitud de reparación fuera de garantía.</li>
                                <li style="font-family: Heebo; font-weight: normal; font-size: 14px;">Si su terminal es APPLE, recuerde desactivar la opción de Buscar Mi iPhone, según este <a class="enlace" target="_blank" href="/doc/DesactivarBMIP.pdf" style="font-family: Heebo; font-weight: normal">procedimiento</a>.</li>
                                <li  style="font-family: Heebo; font-weight: normal; font-size: 14px;">Tenga en cuenta que el daño producido en el dispositivo puede no estar cubierto por la garantía.</li>
                                <li  style="font-family: Heebo; font-weight: normal; font-size: 14px;">Dependiendo de la cobertura del fabricante, las gestión a domicilio de reparaciones dentro de garantía pueden tener un coste tramitación y/o transporte.</li>
                                <li  style="font-family: Heebo; font-weight: normal; font-size: 14px;">Si el dispositivo no ha sido adquirido a través de un distribuidor oficial reconocido por el fabricante puede no estar cubierto por la garantía.</li>
                            </ol>
                            En el caso de Xiaomi puede verificarlo aquí: <a class="enlace" target="_blank" href="https://www.mi.com/global/verify/#/es/tab/imei" style="font-family: Heebo; font-weight: normal">Verificación de producto - Xiaomi</a>
                        </p>
                    </div>
                </div>
            </div>
        </template>
        <!-- Tarjetas catalogo garantias -->
        <div class="form-row maxWidth" style="margin:0" v-if="!this.$bus.formulario.company && hayModeloSeleccionado && hayCatalogo">
            <card-garantia v-if="catalogosReparacion.length > 0" :catalogos-reparacion="catalogosReparacion" :precioEmbalaje=precioEmbalaje :calculoSinEmbalaje="false"></card-garantia>
        </div>
    </div>
</template>

<script>
    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    export default {
        components: {
            parrafoGarantias: () => import("@/components/formulario/parrafoGarantias"),
            cardGarantia: () => import("@/components/formulario/cardGarantia"),
        },
        created() {
            this.getBasicData();
            this.getPrescriptores();
            this.getCatalogo();
        },
        props: {
            dispositivo: Object,
            especiales: Object,
            tipoDNI: {
                type: String,
                default: "",
            },
        },
        filters: {
            kilos: function (val) {
                if (val == "" || val == null || val == 0 || val == undefined)
                    return "No especificado";
                else return val + " kilos";
            },
            precio: function (num) {
                return (Math.round(num * 100) / 100).toFixed(2) + " €";
            },
        },
        data: () => ({
            modelosFiltrados: [],
            sintomas: [],
            accesorios: [],
            prescriptores: [],
            mensajePrescriptor: "",
            facturas: [],
            catalogos: [],
            catalogosReparacion: [],
            catalogo: {},
            precioEmbalaje: 0,
            nombreFichero: "",
        }),
        computed: {
            hayDatosMinimos() {
                return this.hayModelos && this.hayFabricantes && this.hayEmbalajes;
            },
            hayEmbalajes() {
                return this.$bus.embalajes.length > 0;
            },
            embalajes() {
                return this.$bus.embalajes;
            },
            hayFabricantes() {
                return this.$bus.fabricantes.length > 0;
            },
            fabricantes() {
                return this.$bus.fabricantes;
            },
            fabricante: {
                get() {
                    return this.dispositivo.fabricante;
                },
                set(valor) {
                    this.modelosFiltrados = [];
                    this.sintomas = [];
                    this.accesorios = [];
                    this.dispositivo.symptom = "";
                    this.dispositivo.accesories = [];
                    this.dispositivo.model = "";
                    this.dispositivo.tipo = 0;
                    setTimeout((x) => {
                        this.modelosFiltrados = this.$bus.modelos.filter(
                            (x) => x.IDFABRICANTE == valor
                        );
                        this.dispositivo.fabricante = valor;
                    }, 100);
                },
            },
            esRecogidaEnTienda() {
                return this.$bus.formulario.recogida.enTienda;
            },
            hayModelos() {
                return this.$bus.modelos.length > 0;
            },
            hayModelosFiltrados() {
                return this.modelosFiltrados.length > 0;
            },
            hayModeloSeleccionado() {
                return this.dispositivo.model > 0;
            },
            hayCatalogo() {
                return this.catalogosReparacion.length !== 0;
            },
            modelos() {
                return this.$bus.modelos;
            },
            modelo: {
                get() {
                    return this.dispositivo.model;
                },
                set(valor) {
                    this.dispositivo.tipo = 0;
                    this.sintomas = [];
                    this.accesorios = [];
                    this.dispositivo.symptom = "";
                    this.dispositivo.accesories = [];
                    this.getIdTallerMapeo(
                        valor.ID_TIPO_MODELO,
                        valor.IDFABRICANTE,
                        valor.IDMODELO
                    );
                    setTimeout((x) => {
                        this.dispositivo.model = valor.IDMODELO;
                        this.dispositivo.tipo = valor.ID_TIPO_MODELO;
                        this.sintomas = this.$bus.sintomas.filter((x) =>
                            x.TIPOS_MODELOS.includes(valor.ID_TIPO_MODELO)
                        );
                        this.accesorios = this.$bus.accesorios.filter(
                            (x) => x.ID_TIPO_MODELO == valor.ID_TIPO_MODELO
                        );
                    }, 100);
                },
            },
            localPrescriptor: {
                get() {
                    return this.especiales.prescriptor;
                },
                set(valor) {
                    this.especiales.prescriptor = valor;
                    this.mensajePrescriptor = "";
                    this.especiales.prescriptorError = "";

                    if (this.prescriptores.includes(valor)) {
                        this.mensajePrescriptor = "El código introducido es válido";
                    } else {
                        this.especiales.prescriptorError =
                            "El código introducido no es válido";
                    }
                },
            },
        },
        watch: {

            facturas(nuevaFactura) {
                alert("nuevaFactura" + nuevaFactura);
                if (nuevaFactura != undefined && nuevaFactura.length != 0)
                    this.formatearFactura(nuevaFactura);
                else {
                    this.especiales.invoice = [];
                    this.especiales.nombreFacturas = [];
                }
            },
            "especiales.embalaje"(valorCheck) {
                if (!valorCheck) {
                    this.especiales.package = 1;
                    this.precioEmbalaje = 0;
                }
            }
        },
        methods: {
            changeFactura(e) {
                this.nombreFichero = e.target.files[0].name;
                var facturaCambiada = e.target.files[0];
                if (facturaCambiada != undefined && facturaCambiada.length != 0)
                    this.formatearFactura(facturaCambiada);
                else {
                    this.especiales.invoice = [];
                    this.especiales.nombreFacturas = [];
                }
            },
            getBasicData() {
                let json = {
                    keys: [
                        "Modelos",
                        "Manufactures",
                        "Logistics",
                        "Symptoms",
                        "Accessories",
                    ],
                };
                this.$API.getBasicData(json).then((response) => {
                    if (response != "") {
                        this.$bus.modelos = response.Models;
                        this.$bus.fabricantes = response.Manufactures;
                        this.$bus.embalajes = response.Packing;
                        this.$bus.sintomas = response.Symptoms;
                        this.$bus.accesorios = response.Accessories;
                    }
                });
            },
            getPrescriptores() {
                this.$API.CodigosPrescriptores().then((response) => {
                    if (response != "") {
                        this.prescriptores = response.prescriptores;
                    }
                });
            },
            seleccionarPaquete(id, precio) {
                this.especiales.package = id;
                this.precioEmbalaje = precio;
            },
            formatearFactura(file) {
                toBase64(file)
                    .then((data) => {
                        this.especiales.invoice.push(data);
                        this.especiales.invoiceName.push("precarga_" + file.name);
                    })
                    .catch((error) => {
                        alert("Error al obtener las facturas: " + error);
                    });
            },
            getCondicionesAdecuadas() {
                if (this.$bus.login)
                    return "/doc/CondicionesGeneralesServicioTecnicoZeleris_ParticularSuscrito.pdf";
                else if (this.$bus.formulario.company)
                    return "/doc/CondicionesGeneralesServicioTecnicoZeleris_EmpresaRegistrada.pdf";
                else return "/doc/CondicionesGeneralesServicioTecnicoZeleris.pdf";
            },

            /**
             * OBTNER LOS CATALOGOS DE BACKEND
             * @description Llamada a la API para obtener todos los catalogos (MODELOS_TALLER)
             */
            getCatalogo() {
                this.$API.getCatalogo().then((response) => {
                    if (response != "" && response.catalogos.length > 0)
                        this.catalogos = response.catalogos;
                    else this.catalogos = [];
                });
            },

            /**
             * OBTENER EL IDTALLER DEL MAPEO
             * @description Llamada a la API para obtener el identificador del taller que tiene asignada la reparación de dicho modelo
             * Con este identificador obtenemos posteriormente los catalogos (MODELOS_TALLER) que reparan dicho dispositivo en garantía o fuera de garantía.
             * @param {Number} idTipoModelo identificador tipo de modelo del modelo seleccionado
             * @param {Number} idFabricante identificador del fabricante del modelo seleccionado
             * @param {Number} idModelo identificador del modelo seleccionado
             * @property {Object} data request para el servidor, enviando los parametros necesarios para la solicitud del recurso
             */
            getIdTallerMapeo(idTipoModelo, idFabricante, idModelo) {
                let data = {};
                data['idTipoModelo'] = idTipoModelo
                data['idFabricante'] = idFabricante
                data['idModelo'] = idModelo

                this.$API.getIdTallerMapeo(data).then((response) => {
                    console.log(response);
                    if (response != "") {
                        console.log(response);
                        console.log('idTaller --> ' + response.idTaller);
                        this.comprobarCatalogo(response.idTaller, idTipoModelo, idFabricante, idModelo)
                    } else { this.catalogosReparacion = []; }
                });
            },

            /**
             * MÉTODO QUE COMPRUEBA SI HAY UN CATALOGO DE REPARACION PARA UN TALLER
             * @description Llamada a la API para obtener los catalogos (MODELOS_TALLER) que corresponden a un taller, un modelo, un fabricante y/o un tipo de modelo.
             * Catalogos (MODELOS_TALLER) que reparan dicho dispositivo en garantía o fuera de garantía.
             * El método busca de forma jerarquica, de más específico (modelo, fabricante, tipoDeModelo) a menos (tipoDeModelo), teniendo en cuenta que busca por taller en
             * todas las ocasiones. Si no encuentra en un nivel específico pasa a buscar en un nivel menos específico.
             */
            comprobarCatalogo(idTaller, idTipoModelo, idFabricante, idModelo) {

                // Primero buscamos si coincide el modelo exacto
                if (idModelo != undefined && idModelo != null) {
                    this.catalogosReparacion = this.catalogos.filter(
                        (s) =>
                            s.IDMODELO == idModelo &&
                            s.IDTALLER == idTaller
                    )
                }
                // Si no coincide, buscamos por tipo de modelo y fabricante
                if (this.catalogosReparacion.length == 0 && idFabricante != undefined && idFabricante != null && idTipoModelo != undefined && idTipoModelo != null) {
                    this.catalogosReparacion = this.catalogos.filter(
                        (s) =>
                            s.ID_TIPO_MODELO == idTipoModelo &&
                            s.IDFABRICANTE == idFabricante &&
                            s.IDMODELO == null &&
                            s.IDTALLER == idTaller
                    )
                }

                // Si no coincide, buscamos por tipo de modelo
                if (this.catalogosReparacion.length == 0 && idTipoModelo != undefined && idTipoModelo != null) {
                    this.catalogosReparacion = this.catalogos.filter(
                        (s) =>
                            s.ID_TIPO_MODELO == idTipoModelo &&
                            s.IDFABRICANTE == null &&
                            s.IDMODELO == null &&
                            s.IDTALLER == idTaller
                    )
                }
            },
        },
    };
</script>

<style>
    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }

    ::placeholder {
        font-family: Heebo;
        color: #606060;
        font-weight: normal
    }

    textarea::placeholder {
        font-family: Heebo;
        color: #9BA19D;
        font-weight: normal
    }


    #dispositivo .v-autocomplete {
        border: 0px solid white !important;
    }

  
    #dispositivo .centrar-contenido {
        justify-content: center;
    }

    #dispositivo .texto-derecha {
        text-align: end;
    }

    #dispositivo .icono-gigante {
        font-size: 80px;
    }

    #dispositivo .negrita {
        font-weight: bold;
    }

    #dispositivo .seleccionado {
        border: 2px solid #9be51a;
    }

    #dispositivo .enlace {
        color: #9be51a;
    }

    #dispositivo .v-input__append-inner {
        border-bottom: 1px solid #D3D3D3;
    }

    #dispositivo .v-input__slot::after {
        border: 1px solid #9be51a;
      
    }
        #dispositivo .v-input__slot::before {
            display: none;
        }

    /*

    #dispositivo .v-input__slot {
        border: 2px solid #2f272a;
    }


    #dispositivo .v-input--checkbox .v-input__slot {
        border: 0px solid white !important;
    



    #dispositivo ol {
        list-style: decimal;
        margin-left: 2rem;
    }

    #dispositivo ul {
        list-style: circle;
        margin-left: 2rem;
    }

    #dispositivo ml-1 {
        margin-left: 1rem;
    }

    #dispositivo .subrayado {
        text-decoration: underline;
    }

        
    .label-checkbox {
        margin-right: 0.87rem;
        margin-left: auto;
        border: 1px solid #4273DE;
        box-sizing: border-box;
        border-radius: 10px;
        padding: 5px 10px;
        text-align: center;
        display: inline-block;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #4273DE;
    }

    .check-day {
        visibility: hidden;
        position: absolute;
        right: 0;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
    }

    .checked {
        background: #4273DE;
        color: #fff;
    }

        .checked::before {
            content: "✔";
        }

    */
</style>